const initialValue = {
  isLoading: false,
  articles: null,
  addedIndexes: [],
}

export default (state = initialValue, action) => {
  switch (action.type) {
    case 'NEWS_ARTICLES_LOADED': {
      const prev = Array.isArray(state.articles) ? state.articles : [];
      const incoming = Array.isArray(action.payload) ? action.payload : [];
      const articles = prev.concat(incoming)
        .sort((a, b) => b.date.localeCompare(a.date));
      return { ...state, articles };
    }
    case 'NEWS_LOADING_STARTED': {
      return { ...state, isLoading: true, articles: [] };
    }
    case 'NEWS_LOADING_FINISHED': {
      return { ...state, isLoading: false };
    }
    case 'NEWS_ARTICLE_ADDED': {
      return { ...state, addedIndexes: state.addedIndexes.concat(action.payload) };
    }
    default: return state;
  }
}
